/*
|==========================================================================
| WordPress + Foundation
|==========================================================================
| 
| These functions make sure WordPress and Foundation play nice together,
| and this is also where we declare functions defined in this folder.
|
|==========================================================================
|
*/

jQuery(document).ready(function() {

  // Evolving function for WCAG guidelines
  v8_wcag(); 

  // Detect Internet Explorer
  detect_IE();

  // Detect Native Android Browser
  detect_native_android_browser();

  // Apple Device Detect
  apple_device_detect();

  // Enable AOS for use out of the box
  AOS.init({
    disable: 'mobile'
  });

  // Enable skrollr
  // var s = skrollr.init();

  // Gravity Forms Placeholder Clearing
  // gravity_forms_placeholders();

  // Inline SVG replacement
  // inline_svg_replacement();

  // Isotope Masonry
  // isotope_masonry();

  // Gravity Form customize confirmation experience
  gravityform_success_message();

  // Gravity Form Placeholder animation
  jQuery('.contact-form input, .contact-form textarea').focus(function(){
    jQuery(this).parents('.contact-form li.gfield').addClass('focused');
  });

  jQuery('.contact-form input, .contact-form textarea').blur(function(){
    var inputValue = jQuery(this).val();
    if ( inputValue == "" ) {
      jQuery(this).removeClass('filled');
      jQuery(this).parents('.contact-form li.gfield').removeClass('focused');  
    } else {
      jQuery(this).addClass('filled');
    }
  }) 

  // Show single bio in modal window - about
  wp_toggle_team();

  // TablePress Cleanup
  // tablepress();

  // Homepage - Promo Bar

  jQuery('.promo-banner a.close-banner').click(function(e){

      jQuery('.promo-banner').addClass('noshow');

  });

  // Sticky header
  sticky_header();

  jQuery('.owl-carousel').owlCarousel({
    items:1,
    dots:true,
    loop:true,
    margin: 0,
    merge:true,
    autoplay:true,
    autoplayTimeout:10000,
    autoplayHoverPause:true,
  });

  // Event Target Testing
  jQuery(document).click(function(event) {

  });

  // Window scroll detection
  jQuery(window).bind("scroll", function(event) {        
    
    sticky_header();
  
  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
  jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video'/>");
    }
  });

});
